import { Popover } from "@remo-co/ui-core/src/components/Popover";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { useStyles } from "./SamlConfigurationHelperDialogStyles";

interface ISamlConfigurationHelperDialogProps {
  anchorEl: HTMLElement | null;
  isOpen?: boolean;
  handlePopoverClose: () => void;
}

const SamlConfigurationHelperDialog = ({
  anchorEl,
  isOpen,
  handlePopoverClose,
}: ISamlConfigurationHelperDialogProps) => {
  const { t } = useI18n(["sso"]);
  const classes = useStyles();

  return (
    <Popover
      data-testid="saml-configuration-helper-dialog"
      className={classes.popover}
      classes={{ paper: classes.paper }}
      open={Boolean(isOpen)}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
      PaperProps={{ elevation: 1 }}
    >
      <Typography>{t("sso:saml.setup.info.message")}</Typography>
    </Popover>
  );
};

export default SamlConfigurationHelperDialog;
